module.exports = __webpack_public_path__ + "static/media/MF2_0191.3d6ee664.webp";